/**
 * 设置iOS底部安全距离
 * 为根节点添加padding-bottom以适配iOS设备的底部安全区域
 */
export const setIosSafeArea = () => {
	// 获取根节点
	const root = document.documentElement;

	const safeAreaInsetBottom = 34; // 底部安全区域高度
	if (safeAreaInsetBottom > 0) {
		root.style.setProperty("--custom-safe-area-inset-bottom", `${safeAreaInsetBottom}px`);
	}
};

